/// <reference path="./types.d.ts" />

export function getPendo() {
  if (typeof window === 'undefined') {
    return {
      isReady() {
        return false;
      },
    } as Pendo;
  }

  // Until the agent loads, window.pendo is Pendo's snippet stub, which has no isReady.
  if (!window.pendo || typeof window.pendo.isReady !== 'function') {
    console.warn('Pendo is not loaded');
    return {
      isReady() {
        return false;
      },
    } as Pendo;
  }

  return window.pendo;
}

declare global {
  interface Window {
    pendo: Pendo;
  }
}
